import IntroSmall from '@framework/ui/Pages/Landing/Sections/IntroSmall';
import styles from './intro.module.scss';

const Intro = () => (
  <IntroSmall
    className={ styles.intro }
    classNameDescription={ styles.introDescription }
    title="Schedule your operator assisted Evercall."
    description={ (
      <>
        There is no contractual commitment to use Evercall when submitting this form.
        We’ll reach out to confirm details and ask if you wish to proceed.
      </>
    ) }
  />
);

export default Intro;
